import { useState } from "react";
import { useBuyerRelationshipList } from "./api/v2/buyerRelationship/useBuyerRelationshipList";
import { useBuyerRelationshipFavouriteCreate } from "./api/v2/buyerRelationshipFavourite/useBuyerRelationshipFavouriteCreate";

export const useSupplierAddToFavourites = ({
  supplierId,
}: {
  supplierId: number;
}) => {
  const [isAdded, setIsAdded] = useState<boolean>(false);

  const buyerRelationshipListQuery = useBuyerRelationshipList(
    {
      query: [
        {
          type: "supplierId",
          modifier: "EQUALS",
          value: supplierId,
        },
      ],
      limit: 1,
    },

    {
      enabled: !!supplierId,
    },
  );

  const addToFavouritesMutation = useBuyerRelationshipFavouriteCreate();

  const buyerRelationship = buyerRelationshipListQuery.data?.pages[0]?.[0];

  const handleAddToFavourites = () => {
    if (!buyerRelationship?.id) {
      return;
    }

    addToFavouritesMutation.mutate(
      {
        buyerRelationshipId: buyerRelationship.id,
      },
      {
        onSuccess: () => setIsAdded(true),
        onError: () => setIsAdded(false),
      },
    );
  };

  const hasRelationship = buyerRelationship?.BuyerRelationshipFavourite?.id;

  return {
    isAdded: !!hasRelationship || isAdded,
    handleAddToFavourites,
    canAddToFavourites: !!buyerRelationship?.id,
  };
};
